import { useEffect, useState } from 'react'

import { ControllersMappingType } from '@web/extension-services/background/types'
import eventBus from '@web/extension-services/event/eventBus'

/**
 * Native counterpart of useControllerState — drops the react-dom `flushSync`
 * path (not available on React Native). On native, all state updates batch
 * normally, which is fine because mobile UI doesn't have the same
 * rapid-status-flag flicker problem that motivated forceEmit on web.
 */
export default function useControllerState<K extends keyof ControllersMappingType>(
  controllerName: K,
  onUpdateCallback?: (newState: ControllersMappingType[K]) => Promise<void> | void
): ControllersMappingType[K] {
  const [state, setState] = useState({} as ControllersMappingType[K])

  useEffect(() => {
    const onUpdate = (newState: ControllersMappingType[K]) => {
      setState(newState)
      if (onUpdateCallback) onUpdateCallback(newState)
    }

    eventBus.addEventListener(controllerName, onUpdate)
    return () => eventBus.removeEventListener(controllerName, onUpdate)
  }, [controllerName, onUpdateCallback])

  return state
}
